module.exports = __webpack_public_path__ + "static/media/NFT_octopus.5c2e120f.png";